export interface SortState { col: string; dir: 'asc' | 'desc'; }

export function SortIcon({ col, sort }: { col: string; sort: SortState }) {
  const active = sort.col === col;
  return (
    <span className={`sort-icon${active ? ' active' : ''}`}>
      <svg width="7" height="4" viewBox="0 0 8 5"
        fill={active ? (sort.dir === 'asc' ? 'var(--gold)' : 'var(--text-muted)') : 'var(--text-muted)'}>
        <path d="M4 0L8 5H0z" />
      </svg>
      <svg width="7" height="4" viewBox="0 0 8 5"
        fill={active ? (sort.dir === 'desc' ? 'var(--gold)' : 'var(--text-muted)') : 'var(--text-muted)'}>
        <path d="M4 5L0 0h8z" />
      </svg>
    </span>
  );
}
